// Avoids instantiating a new collator on each call (as with localeCompare)
const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true })

/**
 * Locale aware, nullish safe string comparator using a key extractor.
 * Digit runs compare numerically, so "2 - Hardware" sorts before
 * "10 - Building Materials".
 */
export function stringComparator<T>(
  keyExtractor: (t: T) => string | null | undefined
): (a: T, b: T) => number {
  return (a, b) =>
    collator.compare(keyExtractor(a) ?? "", keyExtractor(b) ?? "")
}
